// User service for user-related API calls
import { apiClient } from './apiClient';
import { API_CONFIG } from '../utils/constants';
import { httpClient } from './httpClient';


type EndpointField = keyof typeof API_CONFIG.ENDPOINTS;

export const commonService = {
    cdget: async (): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ENDPOINTS.CD_GET);
        } catch (error) {
            throw error;
        }
    },
    recordUpdate: async (id: any, data: any): Promise<any> => {
        try {
            return await apiClient.put<any>(API_CONFIG.ENDPOINTS.RECORD_UPDATE + id, data);
        } catch (error) {
            throw error;
        }
    },
    recordGetById: async (id: any): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ENDPOINTS.RECORD_GET_BY_ID + id);
        } catch (error) {
            throw error;
        }
    },
    recordDelete: async (id: number): Promise<any> => {
        try {
            return await apiClient.delete<any>(API_CONFIG.ENDPOINTS.RECORD_DELETE + id);
        } catch (error) {
            throw error;
        }
    },
    recordGet: async (page: number, limit: number,search: string): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ENDPOINTS.RECORD_GET + `?page=${page}&limit=${limit}&search=${search}`);
        } catch (error) {
            throw error;
        }
    },
    recordCreate: async (data: any): Promise<any> => {
        try {
            return await apiClient.post<any>(API_CONFIG.ENDPOINTS.RECORD_CREATE, data);
        } catch (error) {
            throw error;
        }
    },
    cdUpdate: async (id: number, data: any): Promise<any> => {
        try {
            return await apiClient.put<any>(API_CONFIG.ENDPOINTS.CD_UPDATE + id, data);
        } catch (error) {
            throw error;
        }
    },
    cdCreate: async (data: any): Promise<any> => {
        try {
            return await apiClient.post<any>(API_CONFIG.ENDPOINTS.CD_CREATE, data);
        } catch (error) {
            throw error;
        }
    },
    search: async (field: EndpointField, query: string): Promise<any> => {
        const data = { "q": query };
        const endpoint = API_CONFIG.ENDPOINTS[field];
        const response = await apiClient.post<any>(endpoint, data);
        return response.data;
    },
    getAll: async (key: EndpointField): Promise<any> => {
        const endpoint = API_CONFIG.ENDPOINTS[key];
        const response = await apiClient.get<any>(endpoint);
        return response.data;
    },
    rdcSearch: async (data: any): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.RDC_SEARCH, data);
        return response.data;
    },
    rdcDownloadRequest: async (data: any): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.RDC_DOWNLOAD_SEARCH, data);
        return response.data;
    },
    fdcAppendOrReplace: async (data: any, actionType: string): Promise<any> => {
        // const response = await apiClient.post<any>(actionType == 'replace' ? API_CONFIG.ENDPOINTS.FDC_REPLACE : API_CONFIG.ENDPOINTS.FDC_APPEND, data);
        // return response.data;

        try {
            return await httpClient.post(
                actionType === 'append' ? API_CONFIG.ENDPOINTS.FDC_APPEND : API_CONFIG.ENDPOINTS.FDC_REPLACE,
                data,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
        } catch (error) {
            throw error;
        }

    },

    fdcDeleteFile: async (fileId: number): Promise<any> => {
        const response = await apiClient.delete<any>(API_CONFIG.ENDPOINTS.FDC_DELETE_FILE + fileId);
        return response.data;
    },

    rdcDownloadList: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.RDC_DOWNLOAD_LIST, data);
        return response.data;
    },
    getCount: async (): Promise<any> => {
        const response = await apiClient.get<any>('count/');
        return response.data;
    },
    rdcDownload: async (request_id: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.RDC_DOWNLOAD + request_id);
        return response.data;
    },
    vdcList: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.VDC_LIST, data);
        return response.data;
    },
    fdcSendSurvey: async (data: any): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_SEND_SURVEY + data);
        } catch (error) {
            throw error;
        }
    },

    vdcDownload: async (request_id: any): Promise<any> => {
        // const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.VDC_DOWNLOAD + request_id);
        // return response.data;

        try {
            return await httpClient.get(
                API_CONFIG.ENDPOINTS.VDC_DOWNLOAD + request_id,
                { responseType: "blob" }
            );
        } catch (error) {
            return error;
        }
    },
    vdcDownloadError: async (request_id: any): Promise<any> => {
        try {
            return await httpClient.get(
                API_CONFIG.ENDPOINTS.VDC_DOWNLOAD_ERROR + request_id + '/errors',
                { responseType: "blob" }
            );
        } catch (error) {
            return error;
        }
    },
    vdcUpload: async (data: FormData): Promise<any> => {
        try {
            return await httpClient.post(API_CONFIG.ENDPOINTS.VDC_UPLOAD, data);
        } catch (error) {
            return error;
        }
    },
    fdcUpload: async (data: FormData): Promise<any> => {
        try {
            return await httpClient.post(
                API_CONFIG.ENDPOINTS.FDC_UPLOAD,
                data,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
        } catch (error) {
            throw error;
        }
    },
    fdcList: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_LIST, data);
        return response.data;
    },
    fdcFilterOptions: async (): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_FILTER_OPTIONS);
        return response.data;
    },
    fdcDefaultParticipants: async (): Promise<{ id: number; name: string }[]> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_DEFAULT_PARTICIPANTS);
        return response.data;
    },
    fdcStatus: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_STATUS + data);
        return response.data;
    },
    fdcGetLead: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_GET_LEAD + data);
        return response.data;
    },
    fdcGetCustomerDetail: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_GET_CUSTOMER_DETAIL + data);
        return response.data;
    },
    fdcLink: async (data: any): Promise<any> => {
        const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.FDC_LINK + data);
        return response.data;
    },
    fdcDelete: async (data: any): Promise<any> => {
        try {
            return await httpClient.patch(
                `${API_CONFIG.ENDPOINTS.FDC_UPDATE_STATUS}${data}`,
                {},  // empty body, if not needed
            );
        } catch (error) {
            return error;
        }
    },
    getProjectId: async (data: any): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_PROJECTID_LIST, data);
        return response.data;
    },
    fdcUpdate: async (data: any): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_UPDATE, data);
        return response.data;
    },
    fdcSetPaymentCompleted: async (projectId: number, paymentCompleted: boolean): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_SET_PAYMENT_COMPLETED, {
            project_id: projectId,
            payment_completed: paymentCompleted,
        });
        return response.data;
    },
    fdcApproveGoodwill: async (projectId: number): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_APPROVE_GOODWILL, {
            project_id: projectId,
        });
        return response.data;
    },
    fdcFlagGrievance: async (projectId: number): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_GRIEVANCE_FLAG, {
            project_id: projectId,
        });
        return response.data;
    },
    fdcUnflagGrievance: async (projectId: number, note?: string): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_GRIEVANCE_UNFLAG, {
            project_id: projectId,
            note: note || undefined,
        });
        return response.data;
    },
    fdcCxApprove: async (projectId: number, comment?: string): Promise<any> => {
        const response = await apiClient.post<any>(`fdc/${projectId}${API_CONFIG.ENDPOINTS.FDC_CX_APPROVE_SUFFIX}`, {
            comment: comment || undefined,
        });
        return response.data;
    },
    fdcCxFlag: async (projectId: number, comment: string): Promise<any> => {
        const response = await apiClient.post<any>(`fdc/${projectId}${API_CONFIG.ENDPOINTS.FDC_CX_FLAG_SUFFIX}`, {
            comment,
        });
        return response.data;
    },
    fdcRegisterCustomer: async (data: {
        first_name: string; last_name?: string; email: string; password: string; product: 'dccp' | 'spokesly';
    }): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_REGISTER_CUSTOMER, data);
        return response.data;
    },
    fdcSendEmail: async (data: any): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_SEND_EMAIL, data);
        return response.data;
    },
    fdcQuickSend: async (projectId: string): Promise<any> => {
        const response = await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_QUICK_SEND + projectId);
        return response.data;
    },
    fdcDownloadFile: async (data: any): Promise<any> => {
        try {
            return await httpClient.get(
                API_CONFIG.ENDPOINTS.FDC_DOWNLOAD_SINGLE + data,
                { responseType: "blob" }
            );
        } catch (error) {
            return error;
        }
    },
    fdcDownloadProject: async (data: any, format: any): Promise<any> => {
        try {
            return await httpClient.get(
                API_CONFIG.ENDPOINTS.FDC_DOWNLOAD_PROJECT + data + "?format=" + format,
                { responseType: "blob" }
            );
        } catch (error) {
            return error;
        }
    },
    fdcFileStatusChange: async (data: any): Promise<any> => {
        try {
            return await httpClient.patch(
                `${API_CONFIG.ENDPOINTS.FDC_FILE_UPDATE_STATUS}${data}`,
                {},  // empty body, if not needed
            );
        } catch (error) {
            return error;
        }
    },

    // STEP 2: upload file chunks
    uploadChunk: async (data: FormData): Promise<any> => {
        try {
            return await httpClient.post(
                API_CONFIG.ENDPOINTS.FDC_UPLOAD_CHUNK,
                data,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
        } catch (error) {
            throw error;
        }
    },

    // STEP 3: finalize upload
    finalUpload: async (projectid: string, taskId?: number | null): Promise<any> => {
        try {
            const formData = new FormData();
            formData.append("projectid", projectid);
            if (taskId) formData.append("task_id", String(taskId));

            return await httpClient.post(
                API_CONFIG.ENDPOINTS.FDC_FINAL_UPLOAD,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
        } catch (error) {
            throw error;
        }
    },
    // finalUpload: async (projectid: any): Promise<any> => {
    //     try {
    //         return await apiClient.post<any>(API_CONFIG.ENDPOINTS.FDC_FINAL_UPLOAD, { projectid });
    //     } catch (error) {
    //         throw error;
    //     }
    // }
};

export default commonService;



